"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// reminder to not import AppUI to avoid circular dependencies
var AudioStream = /*#__PURE__*/function () {
  function AudioStream() {
    _classCallCheck(this, AudioStream);
  }
  return _createClass(AudioStream, [{
    key: "onStreamSuccess",
    value: function onStreamSuccess(stream, levelChangeCallback) {
      this.levelChangeCallback = levelChangeCallback;
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      this.audioContext = new AudioContext();
      var mediaStreamSource = this.audioContext.createMediaStreamSource(stream);
      this.processor = this.createAudioProcessor(this.audioContext);
      mediaStreamSource.connect(this.processor);
    }
  }, {
    key: "startMonitor",
    value: function startMonitor() {
      if (this.processor) {
        this.processor.onaudioprocess = this.getVolumeFromAudio;
        AudioStream.interval = setInterval(this.readMeter.bind(this), 3);
      }
    }
  }, {
    key: "stopMonitor",
    value: function stopMonitor() {
      clearInterval(AudioStream.interval);
      if (this.processor) {
        this.processor.onaudioprocess = null;
      }
    }
  }, {
    key: "readMeter",
    value: function readMeter() {
      if (this.processor) {
        this.levelChangeCallback(this.processor.volume);
      }
    }
  }, {
    key: "createAudioProcessor",
    value: function createAudioProcessor(audioContext) {
      var processor = audioContext.createScriptProcessor(512);
      processor.clipping = false;
      processor.lastClip = 0;
      processor.volume = 0;
      processor.clipLevel = 0.98;
      processor.averaging = 0.95;
      processor.clipLag = 750;
      processor.connect(audioContext.destination);
      return processor;
    }
  }, {
    key: "getVolumeFromAudio",
    value: function getVolumeFromAudio(event) {
      var buf = event.inputBuffer.getChannelData(0);
      var bufLength = buf.length;
      var sum = 0;
      var x;
      var i = 0;
      while (i < bufLength) {
        x = buf[i];
        if (Math.abs(x) >= this.clipLevel) {
          this.clipping = true;
          this.lastClip = window.performance.now();
        }
        sum += x * x;
        i += 1;
      }
      var rms = Math.sqrt(sum / bufLength);
      this.volume = Math.max(rms, this.volume * this.averaging);
    }
  }]);
}();
var _default = exports["default"] = AudioStream;